import * as React from "react";
import { getSiteIconName } from "../../../../utils/CommonUtils";
import CustomIcon from "../../CustomIcons/CustomIcon";
import classes from "./FacilityCard.module.css";

const SummaryFacilityCard = (props) => {
  return (
    <div className={classes.facilityContainer}>
      <div className={classes.cardContent}>
        <CustomIcon
          className={classes.siteIcon}
          iconName={getSiteIconName(props.site.clientId)}
        />
        <div className={classes.cardInfo}>
          <span className={classes.siteName}>{props.site.displayName}</span>
          <span className={classes.siteAddress}>{props.site.address}</span>
          <span className={classes.userType}>{props.userType?.type}</span>
        </div>
      </div>
    </div>
  );
};

export default SummaryFacilityCard;
